import React from "react"
import { RecursiveContentfulContentRendererProps } from "./legacy/content-renderer"
import { ContentRendererForContentfulEntries } from "#/services/contentful/renderer"
import { ContentfulMarkdownOverrides } from "#/services/contentful/contentful-markdown-renderer"

export interface ContentfulContentRendererProps
  extends RecursiveContentfulContentRendererProps,
    ContentfulMarkdownOverrides {}

export function ContentfulContentRenderer({ contents, asList, ...markdownProps }: ContentfulContentRendererProps) {
  return <ContentRendererForContentfulEntries contentfulEntries={contents} asList={asList} {...markdownProps} />
}
